export interface JustificationRules {
  minLength: number
  maxLength: number
}

export interface JustificationValidation {
  valid: boolean
  /** Rendered to the user under the textarea. */
  error?: string
}

/**
 * A justification is always mandatory, so blank text never passes. Bounds are
 * measured on the trimmed text — the same string that gets saved.
 */
export function validateJustification(
  text: string,
  { minLength, maxLength }: JustificationRules
): JustificationValidation {
  const trimmed = text.trim()

  if (trimmed.length === 0) {
    return { valid: false, error: 'A justification is required.' }
  }
  if (trimmed.length < minLength) {
    return {
      valid: false,
      error: `Please write at least ${minLength} characters.`,
    }
  }
  if (trimmed.length > maxLength) {
    return {
      valid: false,
      error: `Please keep this under ${maxLength} characters.`,
    }
  }
  return { valid: true }
}
